


















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormField } from '@/types';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

library.add(faCaretDown);

@Component({
  name: 'form-group'
})
export default class FormGroup extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })
  field!: FormField;

  @Prop()
  value!: any;

  onDataChanged(value: any) {
    if (this.field.onChange) {
      this.field.onChange(value);
    }
    this.$emit('input', value);
  }

  onNestedFieldDataChanged(field: FormField, value: any) {
    // @ts-ignore
    this.value[field.key] = value;
    if (field.onChange) {
      field.onChange(value);
    }
  }
}
